/* eslint-disable react/prop-types */
import { Paragraph } from '@cambridgeassessment/cambridge-ui';
import { ComponentType } from '@cambridgeassessment/lib-ee-commons';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Component } from '../../../../service/components/types';
import SwitchComponent from './DigitallyReceivedControl/SwitchComponent';
import { SamplingAlgorithmDropdown } from './SamplingAlgorithmDropdown';
import {
  StyledComponentDeadlines,
  StyledComponentHeaderContainer,
  StyledComponentHeaderText,
  StyledSamplingAlgorithm,
  TitleAndSwitchFixedWidth,
  StatefulLink,
} from './styles';
import SubmissionValidationPicker from './SubmissionValidationPicker';
import { updateComponent } from '../../../../store/components/thunks';

interface Props {
  component: Component;
  disabled?: boolean;
  readOnly?: boolean;
}

const ComponentRules: React.FC<Props> = ({ component, disabled, readOnly }) => {
  const isDisabled = readOnly || disabled;
  const isComponentExamined = component.type === ComponentType.EXAMINED;
  const showForModeratedComponent = component.type === ComponentType.MODERATED && component.receiveSamples === true;

  const dispatch = useDispatch();

  const handleAllowAdditionalWorkSubmissionChange = () => {
    const updatedComponent = {
      ...component,
      allowAdditionalWorkSubmission: !component.allowAdditionalWorkSubmission,
    };
    dispatch(updateComponent(component._id, updatedComponent, 'allowAdditionalWorkSubmission'));
  };

  return (
    <>
      {!isComponentExamined && (
        <StyledSamplingAlgorithm>
          <SamplingAlgorithmDropdown component={component} disabled={isDisabled} />
        </StyledSamplingAlgorithm>
      )}
      {(showForModeratedComponent || isComponentExamined) && (
        <StyledComponentHeaderContainer>
          <StyledComponentHeaderText>Component/unit rules</StyledComponentHeaderText>
        </StyledComponentHeaderContainer>
      )}
      {showForModeratedComponent && (
        <SubmissionValidationPicker data-qa-id='submission-validation' component={component} disabled={isDisabled} />
      )}
      {!component.isPoE && !component.isExam && (
        <StyledComponentDeadlines>
          <StatefulLink
            data-qa-id='component-deadlines'
            to={`/components/configure-component/${component._id}/deadlines`}
            disabled={isDisabled}
          >
            Configure component deadlines
          </StatefulLink>
        </StyledComponentDeadlines>
      )}
      {(showForModeratedComponent || isComponentExamined) && (
        <TitleAndSwitchFixedWidth>
          <Paragraph data-qa-id={'additional-work-submission-text'}>
            Allow submission of component level documents
          </Paragraph>
          <SwitchComponent
            dataQaId={'additional-work-submission-switch'}
            label={''}
            checked={!!component.allowAdditionalWorkSubmission}
            onChange={handleAllowAdditionalWorkSubmissionChange}
            readOnly={isDisabled}
          />
        </TitleAndSwitchFixedWidth>
      )}
    </>
  );
};

export default ComponentRules;
